<template>
	<!-- 大盒子 -->
	<div class="MedicenCata">
		<!--  描述  -->
		<div class="header">
			<div class="header-icon">
				<i class="el-icon-byj"
					style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #409EFF;color: #fff;"></i>
				<span style="font-size: 12px;font-weight:400;margin-left: 12px;">头部name</span>
				<div class="feetbtn">
					<el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="small" plain @click="feetHandClick(v)">{{ v.label }}</el-button>
				</div>
			</div>
		</div>
		<!-- 主体内容 -->
		<div class="main">
			<!-- 一般用于左侧树菜单 -->
			<div class="main-left">
				<!-- tree -->
				<el-tree 
				:data="elTree"
				:props="defaultProps"
				node-key="label"
				:default-expanded-keys="['全部']"
				accordion 
				@node-click="handleNodeClick"
				class="custom-tree"
				>
				<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
					<span :name="node.label">
						<i v-if="!data.children"
						:class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
						<i v-else class="el-icon-openFile"></i>{{ node.label }}
					</span>
				</span>
				</el-tree>
			</div>
			<!-- 一般用于右侧表格 -->
			<div class="main-right">
				<!-- 表格下搜索 下拉 时间选择按钮事件等 -->
				<div class="main-icon">
					<div class="main-icon-a">
						<i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
						<span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
					</div>
					<!-- btn1 -->
					<div class="main-icon-b">
						<span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
						<el-dropdown @command="handleCommand" trigger="click">
							<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
							<el-dropdown-menu slot="dropdown">
							  <el-dropdown-item command="a">可用</el-dropdown-item>
							  <el-dropdown-item command="b">禁用</el-dropdown-item>
							  <el-dropdown-item command="c" divided>全部</el-dropdown-item>
							</el-dropdown-menu>
					    </el-dropdown>
					</div>
					<!-- btn2 -->
					<div class="main-icon-c">
						<span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
						<el-input size="mini" placeholder="编码、名称、拼音简码" suffix-icon="el-icon-key" v-model="searchValue"></el-input>
					</div>
					<!-- btn3 -->
					<div class="main-icon-c">
						<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" @click="handClick(i)">{{ v.title }}</el-button>
					</div>
				</div>
				<!-- 表格主题 -->
				<!-- 可一个个的el-table-column -->
				<!-- 也可循环tableRows -->
				<!-- handleCurrentTableChange 为单选事件 -->
				<!-- <el-table-column label="第一列" prop=""></el-table-column> -->
				<!-- <el-table-column label="第二列" prop=""></el-table-column> -->
				<!-- <el-table-column label="..." prop=""></el-table-column> -->
				<div class="table">
					<el-table :data="tableData" border highlight-current-row :style="{ width: windowWidth + 'px' }"
					element-loading-text="数据加载中..." v-loading="loading" element-loading-spinner="el-icon-more-outline"
					@current-change="handleCurrentTableChange">
						<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
						<!-- fixed -->
						<el-table-column fixed="left" label="行号" type="index"></el-table-column>
						<!-- edit -->
						<el-table-column fixed="right" label="操作" width="88">
							  <template slot-scope="scope">
								<div class="editbox" style="text-align: center;">
									<el-link type="info" size="mini">修改</el-link>
									<el-link type="danger" size="mini">删除</el-link>
								</div>
							  </template>
						</el-table-column>
					</el-table>
				</div>
				<!-- feet -->
				<div class="feet">
					<!-- 分页 -->
					<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pageNum"
					:page-sizes="[5, 10, 20]"
					:page-size="pageSize"
					:total="totalSize"
					layout="total, sizes, prev, pager, next, jumper"
					background
					>
					</el-pagination>
					
				</div>
			</div>

		</div>
		<!-- 新增等Model -->
		<div class="addModel" v-if="addModelShow">
			新增等内容
		</div>
		
	</div>
</template>

<script>
	// selfs / js
	// import addForm from './addForm.js' //Form表单
	// import AccType from './AddType.js'
	// 接口
	// import { markUppage,docMark,updatedocMark,deldocMark } from "@/api/systemCatalogue/markUp.js";
	export default {
		components: {
			// MedicenCata
		},
		data() {
			return {
				// 树菜单Props
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				// str
				windowWidth:'', //右侧表格动态宽度
				searchValue:'',
				CatalogueName:'右侧Main-right Title',
				DropDownedName:'可用',
				iconComes:'el-icon-byj',
				// boolean
				disabled:true,
				getdisabled:true,
				loading:false,
				addModelShow:false, // 新增控制
				// number
				idx: 0,
				pageNum: 1, //当前页currentPage
				pageSize: 8,
				totalSize: 10, //总条数
				/* obj */
				addForm:{}, // form表单 新增 * 
				editForm:{}, // form表单 修改 * 
				// arr
				data: [],
				userInfo: [],
				tableData: [],
				currentTable:[],
				TypeOption:[
					{ id:1,label:'西药',value:'西药'},{ id:2,label:'中成药',value:'中成药'},
					{ id:3,label:'卫材',value:'卫材'},{ id:4,label:'血液',value:'血液'},
					{ id:5,label:'疫苗',value:'疫苗'},{ id:9,label:'中药',value:'中药'}
				],
				formType:[], // 表单头部内容
				statusOption:[{ id:0,label:'禁用',value:'禁用'},{ id:1,label:'可用',value:'可用'}],
				// title右侧按钮
				headerBtn:[
				 { refesh:"refesh", title:"刷新", type:"", icon:"el-icon-refresh" },
				 { senior:"senior", title:"高级", type:"primary", icon:"" },
				],
				feetBtn:[
				 // { refesh:"refesh", label:"新增", type:"primary", icon:"el-icon-edit" },
				 // { refesh:"refesh", label:"修改", type:"primary", icon:"el-icon-finished" },
				 // { refesh:"refesh", label:"删除", type:"primary", icon:"el-icon-document-checked" },
				 // { refesh:"refesh", label:"查看", type:"primary", icon:"el-icon-sort" },
				 // { refesh:"refesh", label:"打印", type:"primary", icon:"el-icon-printer" },
				 // { refesh:"refesh", label:"导出", type:"primary", icon:"el-icon-finished" },
				 // { refesh:"refesh", label:"关闭", type:"primary", icon:"el-icon-close" },
				 ],
				// title右侧按钮
				tableRows:[
					{ name:"卫材种类", prop:"drugType", type:""},{ name:"价格下限", prop:"pricLmtTop", type:"" },{ name:"价格上限", prop:"pricLmtLow", type:"" },
					{ name:"加成方式", prop:"status", type:"" },{ name:"加成率", prop:"markUpRate", type:"" },
					{ name:"加价金额", prop:"markUpPric", nz:"nz" },{ name:"操作时间", prop:"createTime", type:"" },
					{ name:"操作人", prop:"createId", nz:"nz" },{ name:"有效状态", prop:"state", type:"" },
					{ name:"备注", prop:"remark", type:"" },
				],
				// 表单验证规则
				addFormRules:{},
				elTree:[
					{ label: '全部', path:'', title:'', icon:'el-icon-news',
						children:[
							{ id:1,label: '西药',path:'',title:'西药',icon:'el-icon-xy'},
							{ id:2,label: '中成药',path:'',title:'中成药',icon:'el-icon-zhongchengyao'},
							{ id:3,label: '中草药',path:'',title:'中草药',icon:'el-icon-zhongcaoyao'},
							{ id:4,label: '民族药',path:'',title:'民族药',icon:'el-icon-xyzp'},
							{ id:5,label: '卫材',path:'',title:'卫材',icon:'el-icon-xyjhtxyyzhy'},
							{ id:6,label: '血液',path:'',title:'血液',icon:'el-icon-blood'},
							{ id:7,label: '疫苗',path:'',title:'疫苗',icon:'el-icon-yimiaoke'},
							{ id:8,label: '检验试剂',path:'',title:'检验试剂',icon:'el-icon-tjxg'},
							{ id:9,label: '营养',path:'',title:'营养',icon:'el-icon-cnyyyy'},
						],
					},
				],
			};
		},
		mounted() {
			this.loadData();
			this.getForm();
			//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			})
			// 定义数据来源
			// this.formType = AccType.map(function(val) { return val })
		},
		methods: {
			/*
				数据源
			*/
			loadData(){
				
			},
			// 挂载或销毁前后重新赋值后端参数
			getForm(){
				// 左侧提交表单
				// this.addForm = addForm.map(v => {return v })[0]; // Form
				// this.editForm = addForm.map(v => {return v })[0]; // Form
				// 解构赋值排除 list 属性 => 弃用
				// this.addHeadrForm = addForm.map(item => { let { list, ...newItem } = item; return newItem })[0];
				this.$handlePermissions(); // 引入全局自定义封装方法
			},
			/*
				about tree
			*/
			handleNodeClick(data,e) {
				this.CatalogueName = data.title
				this.iconComes = 'el-icon-' + this.makePy(data.label)
				console.log(this.iconComes);
				this.loadData();
			},
			// add
			addSubmit(){

			},
			// editSubmit
			async editSubmit(){
				//触发验证表单
				this.$refs.editForm.validate(async(valid) => {
				  if(valid){
					//验证通过
					console.log(this.editForm);
					let res = await updatedocMark(this.editForm)
					console.log(res);
					if (res.code === 200){
					this.$message({
						message:res.message,
						type:"success"
					});
					this.editDialogVisible = false
					this.loadData(); //更新数据驱动
					}else{
					  // 失败
					  this.$message({ type: 'error', message: 'fail!'});
					}
				}
				});
			},
			
			/*
				about table
			*/
			// 表单头部聚焦事件 => addForm
			async sname(val,i) {
				// val.id = i;
				this.idx = i;
				// i event
				switch (i) {
					// case 1: 
					// 	if(val === 1){
					// 		this.addForm.markUpPric = ''
					// 		console.log(this.formType)
					// 		// this.disabled = true
					// 	}else{
					// 		this.addForm.markUpRate = '1.0'
					// 	}
					// break;
				}
			},
			// SelectVal to editForm
		    // col 里面包含了表头字段和名称，list 是表格数据
		    columnWidth(col, list) {
				let prop = col.prop,lab = col.lab;
				let width = 40; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
		           if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
		        }
		        width = Math.max(width, len(lab), len(maxlenStr));
		        // 表格自带的内边距(20px) 自调
		        return width + 12; // 这里加了 12px
		        function len(str) {
		           // 实际分配长度可根据需要自行调整
		           let length = 8;
		           for (const char of str + "") {
		             // 英文小写字符 8px
		             if ("a" <= char && char <= "z") length += 8;
		             // 英文大写字符 8px
		             else if ("A" <= char && char <= "Z") length += 8;
		             // 中文字符 28px
		             else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
		             // 其他 8px
		             else length += 12;
		           }
		           return length;
		        }
		    },
			// see table
			// 表格底部循环按钮事件
			feetHandClick(v){
				// v event
				console.log(v);
				if(v.label == '新增'){
					this.addModelShow = true
				}else if(v.label == '修改'){
					
				}else{
					
				}
			},
			// input 
			handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					this.$refs['addForm'].resetFields();
					done();
				  })
				  .catch(_ => {
					
				  });
			},
			// db events
			// 表格单选
			handleCurrentTableChange(val){
				this.currentTable[0] = val
			},

			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑 => 刷新
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({type:'success',message:'已刷新'})
							this.loading = false;		
						}, 1500)
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
				}
			},
			handleCommand(command) {
			  // console.log(command);
			  // 根据 command 值执行相应的逻辑
			  switch (command) {
				case 'a':
				  // 处理a的逻辑
				  console.log('执行A逻辑');
				  this.DropDownedName = '可用'
				  break;
				case 'b':
				  // 处理b的逻辑
				  console.log('执行B逻辑');
				  this.DropDownedName = '禁用'
				  break;
				case 'c':
				  // 处理b的逻辑
				  this.DropDownedName = '全部'
				  break;
				// ... 其他 case
			  }
			},
			// 实时宽度
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 328;
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
			},
			
		}
	}
</script>

<style lang="less" scoped>
	// content
	.MedicenCata {
		height: 100%;
		width: 100%;
		// header
		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			height: 40px;
			background-color: #efefef;
			padding: 4px;

			// justify-content: space-evenly;
			// icon
			.header-icon {
				display: flex;
				align-items: center;
			}
			.feetbtn{
				display: flex;
				justify-content: center;
				margin-left: 12px;
			}
		}

		// main
		.main {
			width: 100%;
			display: flex;
			justify-content: space-between;
			// height: 473px; /* 设置父容器的高度 */
			// overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
			// left
			.main-left {
				/deep/ .el-tree-node__content {
					height: 40px;
					padding-left: 0 !important;
				}
				/deep/ .el-tree-node__label{
					font-size: 12px;
				}
				width: 8%;
				margin-left: 12px;
				background-color: red;
				height: 100%;
			}

			// right
			.main-right {
				flex: 4;
				height: 100%;
				// alert
				.addmessagesBox{
					.tabs{
						/deep/ .el-select>.el-input{
							width: 172px;
						}
						/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
							width: 172px;
						}
						/deep/ .el-form-item__content{
							display: flex;
							
							span{
								font-size: 12px;
							}
						}
						.oneLine{
							width: 524px;
							// background-color: indianred;
						}
					}
					/deep/ .el-dialog__title{
						font-size: 12px;
					}
					/deep/ .el-table{
						font-size: 12px;
					}
				}
				// icon
				.main-icon {
					display: flex;
					align-items: center;
					padding: 12px;
					line-height: 40px;
					.main-icon-a{
						// width: 240px;
						// background-color: #00557f;
					}
					.main-icon-b{
						margin-left: 28px;
						/deep/ .el-dropdown{
							font-size: 12px;
							cursor: pointer;
						}
						/deep/ .el-dropdown:hover {
							font-weight: bold;
							color: #66b1ff;
						}
						/deep/ .el-icon--right{
							// background-color: #66b1ff;
						}
						/deep/ .el-popper[x-placement^=bottom]{
							margin-top: 0;
						}
					}
					// c
					.main-icon-c{
						display: flex;
						margin-left: 28px;
						/deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
							width: 80%;
						}
					}
				}
				// table
				/deep/ .el-table .cell{
					font-size: 12px;
					text-align: center;
				}

				/deep/ .el-table td.el-table__cell div :first-child{
					text-align: center;
				}
				/deep/ .el-table td.el-table__cell div{
					text-align: left;
					overflow: hidden;
					white-space: normal;
					word-break: break-all;
				}
				
				.table{
					
				}
			}
		}
		// addModel
		.addModel{
			margin-left: 12px;
			/deep/ .el-dialog__header{
				padding: 12px;
				line-height: 28px;
				background-color: #007bb0;
			}
			/deep/ .el-dialog__title{
				color: #fff;
				font-size: 12px;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close{
				color: #fff;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
				background-color: brown;
			}
			/deep/ .el-form-item__label{
				font-size: 12px;
			}
		}
		.editModel{
			/deep/ .el-dialog__header{
				padding: 12px;
				line-height: 28px;
				background-color: #007bb0;
			}
			/deep/ .el-dialog__title{
				color: #fff;
				font-size: 12px;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close{
				color: #fff;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
				background-color: brown;
			}
			/deep/ .el-form-item__label{
				font-size: 12px;
			}
		}
		// feet
		.feet {
			padding: 12px;
			
		}

	}
</style>